import { Moment } from "moment";
import { ClipType } from "types";
import { apiGet, apiPut, API_URI } from "./index";

const clip = {
  getAll: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: string) => {
    const data = await apiGet(`${API_URI}/api/clip/getall?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm")}&endDate=${endDate.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds}`);
    return data;
  },
  getAllBins: async (projectIds: string, dateFrom: Moment, dateTo: Moment, streamIds: string) => {
    const data = await apiGet(`${API_URI}/api/clip/getall/bins?projectIds=${projectIds}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamids=${streamIds}`);
    return data;
  },  
  getClipIds: async (projectId: number, clipIds: string[]) => {
    var clips : ClipType[] = [];
    for (let start = 0; start < clipIds.length; start += 100 ){
      const data = await apiGet(`${API_URI}/api/clip/getall/ids?binId=${projectId}&clipIds=${clipIds.slice(start, start+100)}`);
      clips = clips.concat(data);
    }
    // const data = await apiGet(`${API_URI}/api/clip/getall/ids?binId=${projectId}&clipIds=${clipIds.slice(0, 100)}`);
    
    return clips;
  },
  rate: async (projectId: number, favourabilityId: number, binClipBaseIds: number[]) => {
    const body = {
      binClipBaseIds: binClipBaseIds,
      favourabilityId: favourabilityId,
      projectId: projectId,
    };
    const data = await apiPut(`${API_URI}/api/clip/favourability/update`, body);
    return data;
  },
  reject: async (projectId: number, binClipBaseIds: number[]) => {
    const body = {
      binClipBaseIds: binClipBaseIds,
      projectId: projectId,
    };
    const data = await apiPut(`${API_URI}/api/clip/reject`, body);
    return data;
  },
};

export default clip;
